export const getProductDetailsSlotName = (checkoutItemId: string): string =>
  `slot_basket_item_details_${checkoutItemId}`;
